import React, { useCallback } from 'react';
import Colors from '../../../config/Colors';
import { ErrorText } from '../../../components-reactjs/ErrorText';
import { Button } from '../../../components-reactjs/Button';
import { Select } from '../../../components-reactjs/Select';
import { CurrencyInput } from '../../../components-reactjs/CurrencyInput';
import { Formik, Field } from 'formik';
import {
    CONDICAO_FRETE_OPTIONS,
    TIPO_FRETE
} from '../../../constants/configuracao-frete';
import { modalFreteSchema } from '../../../constants/schemas';
import {
    FreteModalContainer,
    ModalHeader,
    ModalHeaderTitle,
    ModalContent,
    FieldContainer,
    Descricao,
    ModalFooter,
    FormAddItem
} from './styles';

export const FretesAddItem = ({
    title,
    selectedCfg,
    handlerAddItem,
    ...props
}) => {
    const labelVlCondition =
        selectedCfg.idTipoCobrancaFrete === TIPO_FRETE.KM
            ? 'Distância em km'
            : 'Valor em reais';

    const placeHolderVlCondition =
        selectedCfg.idTipoCobrancaFrete === TIPO_FRETE.KM ? '0 km' : 'R$ 0';

    const getTpPrioridade = useCallback(() => {
        let tpPrioridade = 1;

        if (!selectedCfg.condicaoFrete.length) {
            return tpPrioridade;
        }

        selectedCfg.condicaoFrete.forEach((condicao) => {
            if (condicao.tpPrioridade > tpPrioridade) {
                tpPrioridade = condicao.tpPrioridade;
            }
        });

        return tpPrioridade + 1;
    }, [selectedCfg]);

    const onSubmit = useCallback(
        async ({ condition, vlCondicaoFrete, vlFrete }) => {
            let valueOfvlCondicaoFrete = vlCondicaoFrete;
            if (typeof vlCondicaoFrete === 'string') {
                valueOfvlCondicaoFrete = vlCondicaoFrete.replace(',', '.');
            }

            let valueOfvlFrete = vlFrete;
            if (typeof vlFrete === 'string') {
                valueOfvlFrete = vlFrete.replace(',', '.');
            }

            const novaCondicao = {
                idClausulaOperador: condition.value,
                vlCondicaoFrete: parseFloat(valueOfvlCondicaoFrete),
                vlFrete: parseFloat(valueOfvlFrete),
                tpPrioridade: getTpPrioridade()
            };

            await handlerAddItem(novaCondicao);

            props.setIsOpen(false);
        },
        [handlerAddItem, props.setIsOpen]
    );

    return (
        <Formik
            initialValues={{
                condition: '',
                vlFrete: '',
                vlCondicaoFrete: ''
            }}
            validationSchema={modalFreteSchema}
            validateOnBlur={false}
            validateOnChange={false}
            onSubmit={onSubmit}
        >
            {({
                errors,
                setFieldValue,
                values,
                handleChange,
                handleSubmit,
                isSubmitting
            }) => {
                return (
                    <FreteModalContainer className="modal-addtime-content">
                        <ModalHeader>
                            <ModalHeaderTitle>{title}</ModalHeaderTitle>
                        </ModalHeader>
                        <ModalContent className="content">
                            <FormAddItem
                                autoComplete="off"
                                onSubmit={handleSubmit}
                            >
                                <FieldContainer marginR={15}>
                                    <Descricao>Condição</Descricao>
                                    <Select
                                        name="condition"
                                        menuPlacement="auto"
                                        selectStyles={{
                                            width: 194,
                                            height: 45
                                        }}
                                        value={values.condition}
                                        options={CONDICAO_FRETE_OPTIONS}
                                        onChange={(option) => {
                                            setFieldValue('condition', option);
                                        }}
                                    />
                                    <ErrorText message={errors.condition} />
                                </FieldContainer>
                                <FieldContainer marginR={15}>
                                    <Descricao>{labelVlCondition}</Descricao>
                                    {selectedCfg.idTipoCobrancaFrete ===
                                    TIPO_FRETE.KM ? (
                                        <>
                                            <CurrencyInput
                                                intlConfig={{}}
                                                disableGroupSeparators
                                                $hasAnError={
                                                    !!errors.vlCondicaoFrete
                                                }
                                                name="vlCondicaoFrete"
                                                placeholder={
                                                    placeHolderVlCondition
                                                }
                                                type="text"
                                                onChange={handleChange}
                                            />
                                            <ErrorText
                                                message={errors.vlCondicaoFrete}
                                            />
                                        </>
                                    ) : (
                                        <Field name="vlCondicaoFrete">
                                            {({ meta }) => {
                                                return (
                                                    <>
                                                        <CurrencyInput
                                                            placeholder="R$ 0"
                                                            $hasAnError={
                                                                !!errors.vlCondicaoFrete
                                                            }
                                                            onValueChange={(
                                                                value
                                                            ) =>
                                                                setFieldValue(
                                                                    'vlCondicaoFrete',
                                                                    value
                                                                )
                                                            }
                                                            value={
                                                                values.vlCondicaoFrete
                                                            }
                                                            allowNegativeValue={
                                                                false
                                                            }
                                                        />
                                                        {!!meta.error && (
                                                            <ErrorText
                                                                message={
                                                                    meta.error
                                                                }
                                                            />
                                                        )}
                                                    </>
                                                );
                                            }}
                                        </Field>
                                    )}
                                </FieldContainer>

                                <FieldContainer>
                                    <Descricao>Preço do frete</Descricao>
                                    <Field name="vlFrete">
                                        {({ meta }) => {
                                            return (
                                                <>
                                                    <CurrencyInput
                                                        placeholder="R$ 0"
                                                        $hasAnError={
                                                            !!errors.vlFrete
                                                        }
                                                        onValueChange={(
                                                            value
                                                        ) =>
                                                            setFieldValue(
                                                                'vlFrete',
                                                                value
                                                            )
                                                        }
                                                        value={values.vlFrete}
                                                        allowNegativeValue={
                                                            false
                                                        }
                                                    />
                                                    {!!meta.error && (
                                                        <ErrorText
                                                            message={meta.error}
                                                        />
                                                    )}
                                                </>
                                            );
                                        }}
                                    </Field>
                                </FieldContainer>
                            </FormAddItem>
                        </ModalContent>
                        <ModalFooter className="buttons">
                            <Button
                                onClick={() => {
                                    props.setIsOpen(false);
                                }}
                                style={{
                                    backgroundColor: `${Colors.grey_light}`,
                                    color: `${Colors.dark}`,
                                    border: `1px solid ${Colors.regular}`,
                                    marginRight: 15,
                                    minHeight: 45,
                                    minWidth: 135
                                }}
                                title="Cancelar"
                            />
                            <Button
                                type="submit"
                                disable={isSubmitting}
                                onClick={handleSubmit}
                                style={{
                                    minHeight: 45,
                                    minWidth: 135,
                                    fontWeight: 'bold'
                                }}
                                title="Adicionar"
                            />
                        </ModalFooter>
                    </FreteModalContainer>
                );
            }}
        </Formik>
    );
};
